import { graphql } from "gatsby";
import React from "react";
import SectionPortfolio from "./SectionPortfolio";

const SectionTechSpecs = ({
  title,
  description,
  techSpecs,
  subhead,
  downloadButton,
}: GatsbyTypes.SectionTechSpecsFragmentFragment) => {
  return (
    <SectionPortfolio
      title={title}
      description={description}
      // @ts-ignore: techSpecs is a little bit different from partners but should works 🤷‍♂️
      partners={techSpecs}
      subhead={subhead}
      link={downloadButton}
      techSpecs={true}
    />
  );
};

export default SectionTechSpecs;

export const fragment = graphql`
  fragment SectionTechSpecsFragment on ContentfulSectionTechSpecs {
    title
    subhead
    description {
      childMarkdownRemark {
        html
      }
    }
    techSpecs {
      logo {
        gatsbyImageData(quality: 90, placeholder: NONE, layout: FULL_WIDTH)
        title
      }
      description {
        childMarkdownRemark {
          html
        }
      }
      name
    }
    downloadButton {
      ...LinkFragment
    }
  }
`;
